import { render, staticRenderFns } from "./CAxCExClarificationsPage.vue?vue&type=template&id=209b57bc"
import script from "./CAxCExClarificationsPage.vue?vue&type=script&lang=js"
export * from "./CAxCExClarificationsPage.vue?vue&type=script&lang=js"
import style0 from "./CAxCExClarificationsPage.vue?vue&type=style&index=0&id=209b57bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports